<template>
    <div>
        <div>
            <video
                id="myVideo"
                ref="video_ref"
                class="video-js vjs-default-skin"
                playsinline
            ></video>
            <canvas
                id="frame_canvas"
                ref="canvas"
                class="frame_canvas"
                :width="500"
                :height="375"
            ></canvas>
            <canvas
                id="cam_check_canvas"
                ref="cam_check_canvas"
                class="cam_check_canvas"
                :width="100"
                :height="100"
            ></canvas>
        </div>
    </div>
</template>
<style>
video {
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
}
</style>
<script>
import 'video.js/dist/video-js.css'
import 'videojs-record/dist/css/videojs.record.css'

import 'webrtc-adapter'
import RecordRTC from 'recordrtc'
import videojs from 'video.js'
/* eslint-disable */
import Record from 'videojs-record/dist/videojs.record.js'

export default {
  data() {
    return {
      player: '',
      cameraLoading: false,
      cameraLoaded: false,
      checkCamTimer:3000,
      firstCamCheck: false,
      isRecording: false,
      thumbnailCapture:false,
      thumbnail:'',
      liveness:false,
      options: {
        src: 'http://127.0.0.1:5000/video_feed#.mp4',
        type: 'video/mp4',
        controls: true,
        autoplay: false,
        fluid: true,
        loop: false,
        width: 500,
        height: 375,
        facingMode: 'environment',
        debug: true,
        controlBar: {
          volumePanel: false,
          pictureInPictureToggle: false,
        },
        plugins: {
          // configure videojs-record plugin
          record: {

            audio: false,
            video: {
              deviceId: {
                exact: this.videoSelected,
              },
            },
            debug: true,
            maxLength: 20,
            // deviceId: { exact: deviceId },
            videoRecorderType: 'auto',
            videoMimeType: 'video/mp4',
          },
        },
      },
      videoSelected: 0,
      videoId: [],
    }
  }, // End of Component > methods

  created() {
    this.$root.$refs.B = this;
  },
  mounted() {
    /* eslint-disable no-console */
    // this.frameCapture();
    console.log('video new scene');
    // this.loadCamera();
    this.checkCam();
    //     this.player = videojs('#myVideo', this.options, () => {
    //       // print version information at startup
    //       var msg =
    //         'Using video.js ' +
    //         videojs.VERSION +
    //         ' with videojs-record ' +
    //         videojs.getPluginVersion('record') +
    //         ' and recordrtc ' +
    //         RecordRTC.version
    //       videojs.log(msg)
    //     })
    //
    //     this.player.record().getDevice()
    //
    //     this.player.record().enumerateDevices()
    //
    //     this.player.record().setVideoInput(this.deviceId)
    //
    //     console.log(this.player.record().devices)
    //     var $this = this
    //     this.player.on('enumerateReady', function () {
    //       console.log($this.player.record().devices)
    //       var devices = $this.player.record().devices
    //       console.log(devices[2])
    //       devices.forEach(function (device) {
    //         if (device.kind == 'videoinput') {
    //           $this.videoId.push(device)
    //         }
    //       })
    //       console.log($this.videoId)
    //     })
    //
    //     // error handling
    //     this.player.on('enumerateError', function () {
    //       console.log('Camera not found')
    //       console.log('enumerate error:', this.player.enumerateErrorCode)
    //     })
    //
    //     // device is ready
    //     this.player.on('deviceReady', () => {
    //       console.log('Camera Found')
    //       console.log('device is ready!')
    //     })
    //
    //     // user clicked the record button and started recording
    //     this.player.on('startRecord', () => {
    //       this.$emit('recordingStarted')
    //       console.log('Start Record Called')
    //       //this.print()
    //       // console.log('width: ', this.$refs.video_stream.width)
    //       // console.log('height: ', this.$refs.video_stream.height)
    //       // let el = this.$refs.video_stream.$el
    //       // let options = { type: 'dataURL' }
    //       // console.log('new video stream: ', this.$html2canvas(el, options))
    //     })
    //
    //     this.player.on('stopRecord', () => {
    //       //this.$emit('recordingStarted')
    //       console.log('Stop Record Called')
    //     })
    //
    //     // user completed recording and stream is available
    //     this.player.on('finishRecord', () => {
    //       console.log('Finish Record Called')
    //       // the blob object contains the recorded data that
    //       // can be downloaded by the user, stored on server etc.
    //       this.$emit('recordingEnded', this.player)
    //     })
    //
    //     // error handling
    //     this.player.on('error', (element, error) => {
    //       console.warn(error)
    //     })
    //
    //     this.player.on('deviceError', () => {
    //       console.error('device error:', this.player.deviceErrorCode)
    //     })
    //     this.onLoad()
  },
  beforeDestroy() {
    if (this.player) {
      console.log('Player Disposed !!!!!!!!!!!!!!!!!!!!!!!!!!')
      this.player.dispose()
    }
  },


  /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
  methods: {

    checkCamera(){

      console.log('Checking for Camera');
      try {
        this.player.record().getDevice()
      }
      catch (e) {
        console.log('Get Device Error: ', e)
      }

    },

    closeCamera(){
      this.player.record().stopDevice();
    },
    checkCam(){

      if (this.liveness !== true) {
      console.log('Checking for Camera: ', this.cameraLoading)

      setTimeout(() => {

        if (this.cameraLoading === false) {

          let canvas_size = 0;
          try {
            const type = "image/jpeg";
            let context = document.getElementById("cam_check_canvas").getContext("2d");
            context.drawImage(this.player.record().mediaElement, 0, 0);
            const canvas = document
              .getElementById("cam_check_canvas")
              .toDataURL(type)
              .replace("data:" + type + ";base64,", "");

            canvas_size = canvas.length;
            console.log('SIZE AT JS: ', canvas_size)
          } catch (e) {
          }
          finally {
            if (canvas_size <= 1216 && this.liveness !== true){
              this.$root.$refs.A.toggleCamera(false);
              this.cameraLoading = true;
              if (this.firstCamCheck === false) {
                  this.loadCamera();
                  this.firstCamCheck = true;
              } else {
                if (this.isRecording){
                  this.resetRecorder();
                }
                this.reloadCamera();
              }
            } else {
              this.$root.$refs.A.toggleCamera(true);
            }
          }
        }
        this.checkCam()
      }, this.checkCamTimer)
      }
    },
    reloadCamera(){
      this.player.record().setVideoInput(this.deviceId);
    },
    setLiveness(status){
      this.liveness = status;
    },
    loadCamera() {

      // if (this.cameraLoaded){
      //
      //     this.player.record().getDevice()
      //
      //   return;
      // }

      var startDate = new Date();

      console.log('Loading Camera ......')
      this.player = videojs('#myVideo', this.options, () => {
        // print version information at startup
        var msg =
          'Using video.js ' +
          videojs.VERSION +
          ' with videojs-record ' +
          videojs.getPluginVersion('record') +
          ' and recordrtc ' +
          RecordRTC.version
        videojs.log(msg)
      })


      this.player.record().getDevice()



      // this.player.record().enumerateDevices()
      //
      // this.player.record().setVideoInput(this.deviceId)
      //
      // // console.log(this.player.record().devices)
      // var $this = this
      // this.player.on('enumerateReady', function () {
      //   // console.log($this.player.record().devices)
      //   var devices = $this.player.record().devices
      //   // console.log(devices[2])
      //   devices.forEach(function (device) {
      //     if (device.kind == 'videoinput') {
      //       $this.videoId.push(device)
      //     }
      //   })
      //   // console.log($this.videoId)
      // })

      // error handling
      this.player.on('enumerateError', function () {
        console.log('Camera not found')
        console.log('enumerate error:', this.player.enumerateErrorCode)
      })

      // device is ready
      this.player.on('deviceReady', () => {
        var endDate = new Date();
        var seconds = (endDate.getTime() - startDate.getTime()) / 1000;
        this.cameraLoading = false;
        this.cameraLoaded = true;
        console.log('Camera Found: ', seconds)
        console.log('device is ready!')
      })

      // user clicked the record button and started recording
      this.player.on('startRecord', () => {
        this.isRecording = true;
        this.thumbnailCapture = true;
        this.$emit('recordingStarted')
        console.log('Start Record Called')
      })

      this.player.on('stopRecord', () => {
        //this.$emit('recordingStarted')
        this.checkCamTimer = 2000;
        this.isRecording = false;
        console.log('Stop Record Called')
      })

      this.player.on('progressRecord', () => {
        this.checkCamTimer = 5000;
      })

      // user completed recording and stream is available
      this.player.on('finishRecord', () => {
        console.log('Finish Record Called')
        // the blob object contains the recorded data that
        // can be downloaded by the user, stored on server etc.
        this.checkCamTimer = 2000;
        this.$emit('recordingEnded', this.player)
      })

      // error handling
      this.player.on('error', (element, error) => {
        console.warn(error)
        console.log('Error Occurred !!!!!!!!!!!')
      })

      this.player.on('deviceError', () => {
        this.cameraLoading = false;
        this.cameraLoaded = true;
        console.error('device error:', this.player.deviceErrorCode)
      })

      this.onLoad()


      ////////// Image Player////////////////////////////////////////////////////////////////////////////////////////////////////



      //////////


    },
    
    resetRecorder(){
        this.$emit('recordingEnded', this.player)
        this.player.record().reset();
    },
    
    getThumbnail(){
      return this.thumbnail;
    },
    sendFrame(){

      let width = this.player.record().mediaElement.videoWidth;
      let height = this.player.record().mediaElement.videoHeight;
      console.log('IM HIT IM HIT !!!!!', width, height);
      const type = 'image/jpeg';
      (document.getElementById('frame_canvas')).width = width;
      (document.getElementById('frame_canvas')).height = height;
      let context = document.getElementById("frame_canvas").getContext("2d");
      context.drawImage( this.player.record().mediaElement, 0, 0, width, height);
      const canvas = document
        .getElementById("frame_canvas")
        .toDataURL(type)
        .replace("data:" + type + ";base64,", "");

      if (this.thumbnailCapture){
        this.thumbnail = document
          .getElementById("frame_canvas")
          .toDataURL(type)
        this.thumbnailCapture = false
      }
      
      console.log('SIZE AT JS: ', canvas.length)
      return canvas

    },
    onClick() {
      var length = this.videoId.length - 1
      if (this.videoSelected >= length) {
        this.videoSelected = 0
        this.options.plugins.record.video.deviceId.exact =
          this.videoId[this.videoSelected].deviceId
      } else {
        this.videoSelected++
        this.options.plugins.record.video.deviceId.exact =
          this.videoId[this.videoSelected].deviceId
      }
    },
    onLoad() {
      var $this = this
      setTimeout(function () {
        //console.log('type2:', typeof $this.videoId[0].deviceId)
        //console.log('type1: ', typeof $this.options.plugins.record.video.deviceId.exact)

        if ($this.videoId[0] !== undefined) {
          $this.options.plugins.record.video.deviceId.exact =
            $this.videoId[0].deviceId
        }
      }, 500)
    },
  },
}
</script>

<style>
#frame_canvas{
  display: none;
  /*position: absolute;*/
  z-index: 4;
}
#cam_check_canvas{
  display: none;
  z-index: 4;
}

</style>
